module.exports = __webpack_public_path__ + "img/1077.5b222ced.gif";